import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import { ZIndex } from "config/zIndex";
import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(8, 18, 30, 0.45);
  display: flex;
  justify-content: flex-end;
  z-index: ${ZIndex.sidePanel};
`;

export const Panel = styled.div`
  width: 760px;
  max-width: 98vw;
  height: 100%;
  max-height: 100dvh;
  background: ${ColorV2.Blue7};
  box-shadow: -12px 0 32px rgba(15, 42, 64, 0.2);
  padding: 56px 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: hidden;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-left: 24px;
`;

export const Title = styled.h2`
  ${TypographyV2.h2}
  color: ${ColorV2.Blue1};
  margin: 0;
`;

export const CloseButton = styled(SecondaryButton)`
  flex-shrink: 0;
`;

export const PanelBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding-right: 10px;
  margin-right: -10px;
`;

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 560px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const FullWidthField = styled.div`
  grid-column: 1 / -1;
`;

export const PhoneContinueButton = styled(PrimaryButton)`
  width: fit-content;
  min-width: 132px;
  justify-self: start;
  align-self: start;
  margin-top: 40px;
`;

export const PhoneFieldsSpacer = styled(FullWidthField)`
  height: 10px;
`;

export const Footer = styled.div`
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  justify-content: center;
`;

export const SubmitErrorText = styled.p`
  ${TypographyV2.s1}
  color: ${ColorV2.NegativeRed};
  margin: 0;
`;
